"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const work_details_schema_1 = __importDefault(require("@Entities/schemas/work/work-details-schema"));
const zod_1 = require("zod");
const alternative_title_schema_1 = __importDefault(require("@Entities/schemas/work/alternative-title-schema"));
const publisher_schema_1 = __importDefault(require("@Entities/schemas/work/publisher-schema"));
const writer_schema_1 = __importDefault(require("@Entities/schemas/work/writer-schema"));
const recording_schema_1 = __importDefault(require("@Entities/schemas/work/recording-schema"));
const error_messages_1 = require("@Entities/schemas/work/error-messages");
const workSchema = work_details_schema_1.default.extend({
    lastErrorMessage: zod_1.z.any().optional().nullable(),
    topPublisherIpId: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('Top publisher ID') })
        .optional()
        .nullable(),
    masterTransactionId: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('Master transaction ID') })
        .optional()
        .nullable(),
    id: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('ID') })
        .optional()
        .nullable(),
    alternativeTitles: zod_1.z.array(alternative_title_schema_1.default),
    originalPublishers: zod_1.z.array(publisher_schema_1.default).min(1, 'Work must have at least 1 publisher'),
    writers: zod_1.z
        .array(writer_schema_1.default)
        .min(1, 'Work must have at least 1 writer')
        .refine((writers) => writers.some((writer) => writer.roleCode === 10 || writer.roleCode === 11), {
        message: 'At least one Composer/Author or Composer writer role is required to submit a work registration.',
        path: [0, 'roleCode'],
    }),
    recordings: zod_1.z.array(recording_schema_1.default),
    isComplete: zod_1.z.boolean(),
    errors: zod_1.z.any(), // what do?
    updateDate: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Update date') }).nullable(),
    totalKnownShares: zod_1.z.number({ invalid_type_error: (0, error_messages_1.numericMessage)('Total known shares') }).nullable(),
    registrationHistoryStatus: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Registration history status') })
        .max(20, (0, error_messages_1.stringSizeMaxMessage)('Registration history status', 20))
        .nullable(),
    registrationHistoryIndicator: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Registration history indicator') })
        .max(20, (0, error_messages_1.stringSizeMaxMessage)('Registration history indicator', 20))
        .nullable(),
    parent: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('Parent') })
        .nullable()
        .optional(),
    registrationHistoryDate: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Registration history date') }).nullable(), // ISO8601
    submissionDate: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Submission date') })
        .nullable()
        .optional(), // ISO8601
    submissionId: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Submission ID') })
        .nullable()
        .optional(),
    songCode: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Song code') }).optional(),
    referenceId: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Reference ID') })
        .optional()
        .nullable(),
    sourceId: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('Source ID') })
        .optional()
        .nullable(),
    propertyId: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Property ID') }).nullable(),
    oldDerivative: zod_1.z.boolean().optional().nullable(),
    preTerminationEndDate: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Pre-Termination end date') })
        .optional()
        .nullable(),
    localId: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Local ID') }).optional(),
    publicDomainFlag: zod_1.z.string({ invalid_type_error: (0, error_messages_1.stringMessage)('Public domain flag') }).optional(),
});
exports.default = workSchema;
